module.exports = __webpack_public_path__ + "static/media/invites_paper@1x.1c0fe4e4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/invites_paper@1x.png
 ** module id = 904
 ** module chunks = 44
 **/